var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-autocomplete", {
    staticClass: "search-bar",
    attrs: {
      id: "findLeadsInput",
      size: "is-normal",
      field: "nameLastName",
      rounded: "",
      expanded: _vm.expanded,
      icon: "search",
      data: _vm.leads,
      placeholder: _vm.placeholder,
      loading: _vm.isLoading,
    },
    on: { select: (option) => _vm.$emit("select", option) },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (props) {
          return [
            _c("div", [
              _c("div", { staticClass: "result-list" }, [
                _vm._v(
                  " " +
                    _vm._s(`${props.option.name} ${props.option.lastName}`) +
                    " "
                ),
                _c("br"),
                _c("small", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("idNumber")) +
                      ": " +
                      _vm._s(props.option.idNumber) +
                      ", " +
                      _vm._s(_vm.$t("email")) +
                      ": "
                  ),
                  _c("strong", [_vm._v(_vm._s(props.option.email))]),
                  _vm._v(
                    ", " +
                      _vm._s(_vm.$t("phono")) +
                      ": " +
                      _vm._s(props.option.phone) +
                      " "
                  ),
                ]),
              ]),
            ]),
          ]
        },
      },
      {
        key: "empty",
        fn: function () {
          return [_vm._v(_vm._s(_vm.emptyMessage))]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.searchString,
      callback: function ($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }